const REPORTS_API_BASE_URL = import.meta.env.VITE_REPORTS_API_BASE_URL || "";
const SUMMARY_TYPESENSE_COLLECTION = "paralegal";

function escapeFilterValue(value) {
  return `\`${String(value).replace(/`/g, "\\`")}\``;
}

function getFirstDocument(searchResult) {
  return searchResult?.hits?.[0]?.document || null;
}

function buildSearchUrl(caseNumber, exact = true) {
  const params = new URLSearchParams({
    q: caseNumber,
    query_by: "standard_casenumber",
    infix: "always",
    per_page: "1",
  });

  if (exact) {
    params.set("filter_by", `standard_casenumber:=${escapeFilterValue(caseNumber)}`);
  }

  return `${REPORTS_API_BASE_URL}/collections/${SUMMARY_TYPESENSE_COLLECTION}/documents/search?${params}`;
}

async function fetchSummaryDocument(caseNumber, exact = true) {
  const response = await fetch(buildSearchUrl(caseNumber, exact));

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`Failed to load case summary: ${response.status}`);
  }

  return getFirstDocument(await response.json());
}

export async function getCaseByStandardCaseNumberFromReports(standardCaseNumber) {
  const caseNumber = String(standardCaseNumber || "").trim();

  if (!caseNumber) {
    return null;
  }

  if (!REPORTS_API_BASE_URL) {
    throw new Error("Reports API base URL is not configured.");
  }

  return (
    (await fetchSummaryDocument(caseNumber, true)) ||
    (await fetchSummaryDocument(caseNumber, false)) ||
    null
  );
}
